export const ringFaqs = [
  {
    question: "دلبند چگونه برنامه روزانه هوشمند پیشنهاد می‌دهد؟",
    answer: "با تحلیل الگوهای خواب، ضربان قلب و سطح استرس، دلبند برنامه‌ای متناسب با شرایط جسمی و روحی شما پیشنهاد می‌دهد تا بهره‌وری را حداکثر کنید. مناسب برای صبح‌های پربار با تگ‌های \"مدیریت زمان\" و \"برنامه‌ریزی\"."
  },
  {
    question: "چگونه داده‌ها را با گوشی همگام‌سازی کنم؟",
    answer: "از طریق اپلیکیشن دلبند روی iOS یا Android با بلوتوث متصل می‌شود؛ داده‌ها به صورت real-time sync شده و گزارش‌های تحلیلی ارائه می‌دهد."
  },
  {
    question: "حلقه‌های دلبند از چه موادی ساخته شده‌اند؟",
    answer: "حلقه‌ها از مواد سبک و مقاوم مانند تیتانیوم یا نانو سرامیک hypoallergenic ساخته شده‌اند که برای پوست‌های حساس مناسب است و وزن کمی دارد. مدل‌های پیشرفته ممکن است روکش‌های فلزی مانند نقره داشته باشند."
  },
  {
    question: "چه ویژگی‌های سلامتی را اندازه‌گیری می‌کنند؟",
    answer: "پایش دقیق ضربان قلب، ECG پزشکی، دمای بدن، سطح استرس، کیفیت خواب و فعالیت‌های روزانه مانند قدم‌ها و کالری را پشتیبانی می‌کنند. مناسب برای ورزشکاران حرفه‌ای و نظارت سلامت عمومی."
  },
  {
    question: "عمر باتری محصولات دلبند چقدر است؟",
    answer: "حلقه هوشمند دلبند با یک بار شارژ تا 10 روز کار می‌کند. ساعت هوشمند کلاسیک تا ۵ روز و ساعت هوشمند کودکان تا ۳ روز با استفاده معمولی شارژ نگه می‌دارد. زمان شارژ کامل برای تمامی محصولات کمتر از ۲ ساعت است."
  },
  {
    question: "چگونه دلبند به بیداری آرام پس از خواب عالی کمک می‌کند؟",
    answer: "دلبند کیفیت خواب شب گذشته را تحلیل کرده و بر اساس ریتم بدنی، بهترین زمان بیداری را تنظیم می‌کند تا هر صبح با انرژی و نشاط بیدار شوید. این ویژگی با تگ‌های \"خواب بهتر\" و \"انرژی روزانه\"، شروع روز را ایده‌آل می‌سازد."
  }
];